import { gql, TypedDocumentNode } from '@apollo/client';

export type RewardsSummary = {
  __typename: 'RestRewardsSummary';
  attributes: {
    __typename: 'RestRewardsSummaryAttributes';
    expiresOn: string;
    getRewardsData: GetRewardsData;
    getRewardsSummary: GetRewardsSummary;
  };
};

export type GetRewardsData = {
  __typename: 'RestGetRewardsData';
  redeemableAmount: string;
  pointsRequired: number;
  enrolledForLoyalty: boolean;
  totalRewardsPointsWithDelimeter: string;
  rewardsCurrencyData: RewardsCurrencyData;
};

export type RewardsCurrencyData = {
  __typename: 'RestRewardsCurrencyData';
  currencySymbol: string;
  thresholdAmount: number;
  thresholdPoint: string;
};

export type GetRewardsSummary = {
  __typename: 'RestGetRewardsSummary';
  summary: GetRewardsSummarySummary[];
  currentPageNumber: number;
  totalRecords: number;
};

export type GetRewardsSummarySummary = {
  __typename: 'RestGetRewardsSummarySummary';
  date: string;
  reason: string;
  qualifyingSpent: string;
  id: string;
  earnedPoints: string;
  totalPoints: string;
  editedBy: string;
  pendingForApproval: number;
};

export type GetRewardsSummaryQueryVariables = {
  countryCode: string;
  currency: string;
  pageNumber: number;
  pageSize: number;
};

export type GetRewardsSummaryQuery = {
  getRewardsSummary: {
    __typename: 'RestRewardsSummary';
    data: RewardsSummary[];
  };
};

export const REWARDS_SUMMARY_FRAGMENT = gql`
  fragment RewardsSummaryFragment on RestRewardsSummary {
    attributes @type(name: "RestRewardsSummaryAttributes") {
      expiresOn: expires_on
      getRewardsData: get_rewards_data @type(name: "RestGetRewardsData") {
        redeemableAmount: redeemable_amount
        pointsRequired: points_required
        enrolledForLoyalty: enrolled_for_loyalty
        totalRewardsPointsWithDelimeter: total_rewards_points_with_delimeter
        rewardsCurrencyData: rewards_currency_data @type(name: "RestRewardsCurrencyData") {
          currencySymbol: currency_symbol
          thresholdAmount: threshold_amount
          thresholdPoint: threshold_point
        }
      }
      getRewardsSummary: get_rewards_summary @type(name: "RestGetRewardsSummary") {
        currentPageNumber: page
        totalRecords: total_record_count
        summary: summary @type(name: "GetRewardsSummarySummary") {
          date: date
          reason: reason
          qualifyingSpent: qualifying_spent
          earnedPoints: earned_points
          totalPoints: total_points
          id
          editedBy: edited_by
          pendingForApproval: pending_for_approval
        }
      }
    }
  }
`;

export const GET_REWARDS_SUMMARY_QUERY: TypedDocumentNode<
  GetRewardsSummaryQuery,
  GetRewardsSummaryQueryVariables
> = gql`
  query GetRewardsSummaryQuery(
    $countryCode: String!
    $currency: String
    $pageNumber: Number
    $pageSize: Number
  ) {
    getRewardsSummary(
      country_code: $countryCode
      selected_currency: $currency
      page: { number: $pageNumber, size: $pageSize }
    )
      @rest(
        type: "RestRewardsSummary"
        endpoint: "user_loyalty_rewards_summaries"
        path: "/v3.5/user_loyalty_rewards_summaries?{args}"
      ) {
      data @type(name: "RestRewardsSummary") {
        ...RewardsSummaryFragment
      }
    }
  }
  ${REWARDS_SUMMARY_FRAGMENT}
`;
